import axios from 'axios';

let prefix = "/tax"

const TaxApi = {

	getTaxList(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	getTaxById(id){
		return axios.get( prefix + "/get/" + id)
	},
	createTax(payload){
		return axios.post( prefix + "/create", payload)
	},
	updateTax(payload){
		return axios.post( prefix + "/update", payload)
	},
	deleteTax(id){
		return axios.delete( prefix + "/delete", {params: {id: id}})
	},
}

export default TaxApi;
